import { useEffect, useState } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { hydrateAuthLeadershipTier, isLeadershipTierLoaded } from '@/utils/auth-profile';

/** 确保 auth.user.leadershipTier 已从 /me 同步，供路由分流使用 */
export function useAuthProfileReady() {
  const user = useAuthStore((state) => state.user);
  const [ready, setReady] = useState(() => !user || isLeadershipTierLoaded(user));

  useEffect(() => {
    if (!user) {
      setReady(true);
      return;
    }

    if (isLeadershipTierLoaded(user)) {
      setReady(true);
      return;
    }

    let cancelled = false;
    setReady(false);
    void hydrateAuthLeadershipTier().finally(() => {
      if (!cancelled) {
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [user?.id, user?.leadershipTier]);

  return { ready, user };
}
